document.addEventListener('DOMContentLoaded', () => {
  const allContainers  = document.querySelectorAll('.image-content');

  if (!allContainers.length) return;

  allContainers.forEach(container => {
    const containers = container.querySelectorAll('.image-content__item');
    const customDots = container.querySelector('.content-slider');

    if (!containers.length) return;

    container.querySelectorAll('.scrolling-text-wrapper').forEach(wrapper => {
      const text = wrapper.querySelector('.scrolling-text');
      const inner = wrapper.querySelector('.scrolling-text-inner');
      if (!text || !inner) return;

      inner.style.display = 'inline-block';

      const wrapperHeight = wrapper.offsetHeight;
      const innerHeight = inner.offsetHeight;

      // if (innerHeight >= wrapperHeight * 0.66666) return

      let totalHeight = innerHeight;
      let count = 0;

      for (let i = 0; i < 6; i++) {
        text.appendChild(inner.cloneNode(true))
        totalHeight = text.scrollHeight
      }
      // while (totalHeight < wrapperHeight * 2 && ++count < 10) {
      // }
    });

    containers.forEach(section => {
      const container = section.querySelector('.image-content__image--container');
      const buttons = section.querySelectorAll('.image-content__block-title');
      const sliderItems = container.querySelectorAll('.image-content__image--content');

      if (sliderItems.length <= 1) return;

      const flkty = new Flickity(container, {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: false,
        autoPlay: false,
        adaptiveHeight: false,
        percentPosition: true,
        setGallerySize: window.innerWidth < 990
      });

      const updateState = (index, manualChange) => {
        buttons.forEach((btn, i) => {
          btn.classList.toggle('is-selected', i === index)
          if (manualChange) {
            const parent = btn.closest('.image-content__item')
            if (parent) {
              const header = getEl('sticky-header')
              if (header) parent.style['scroll-margin-top'] = `${header.scrollHeight + 30}px`;
              parent.scrollIntoView({ behavior: 'smooth', block: 'start' })
            } 
          } 
        });
        sliderItems.forEach((item, i) => item.classList.toggle('fade-in', i === index));
      };

      updateState(flkty.selectedIndex);

      flkty.on('change', index => {
        updateState(index, true);
        updateDots(index);
      });

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => flkty.select(index, false, true));
      });

      let dotElements = [];

      const updateDots = (activeIndex) => {
        dotElements.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      };

      if (customDots) {
        sliderItems.forEach((_, index) => {
          const dot = document.createElement('span');
          dot.className = 'slider-dot';
          if (index === flkty.selectedIndex) dot.classList.add('is-active');

          dot.addEventListener('click', () => {
            flkty.select(index, false, true);
          });

          customDots.appendChild(dot);
          dotElements.push(dot);
        });
      }
    });
  });
});
